<template>
  <div class="pt-3 payment-info">
    <div>
      <section>
        <div class="index-content centered-block" :class="{'card-design-for-ie': isIE}">
          <b-col lg="8">
            <div class="order-main payment-sources">
              <div class="px-3 pt-3 px-md-4 pt-md-4  d-flex flex-column">
                <div v-if="paymentSources && paymentSources.length">
                  <div v-for="paymentSource in paymentSources" :key="paymentSource.id" class="payment-source-item rounded mb-3" :class="selectedPaymentSource && 'py-2 py-sm-0'" >
                    <div class="payment-source-card-label">
                      <div class="py-2 payment-source-number">
                        <div class="py-2 d-block d-sm-none">
                          <span v-if="paymentSource.isActive">
                            <font-awesome-icon style="color: #8BC31F"  :icon="['fas', 'circle']"
                                               class="footer_btn pr-1"></font-awesome-icon>
                          </span>
                          <span v-else>
                            <font-awesome-icon style="color: #FF5C5E"  :icon="['fas', 'circle']"
                                               class="footer_btn pr-1"></font-awesome-icon>
                          </span>
                        </div>
                        <img class="footer-btn card-icon" :src="require(`@/assets/images/${getCardIcon(paymentSource.type.toLowerCase())}.svg`)"/>
                        <span class="pl-sm-2 pl-1 d-none d-sm-block">**** **** **** {{paymentSource.last4}}</span>
                        <span class="pl-sm-2 pl-1 d-block d-sm-none">{{paymentSource.last4}}</span>
                      </div>
                      <div class="py-2 pr-3 payment-source-expiry">
                        {{paymentSource.expDate}}
                      </div>
                      <div class="py-2 d-none d-sm-block flex-grow-1">
                        <button class="btn">
                            <span v-if="paymentSource.isActive">
                              <font-awesome-icon style="color: #8BC31F"  :icon="['fas', 'circle']"
                                                 class="footer_btn pr-1"></font-awesome-icon> Active
                            </span>
                          <span v-else>
                              <font-awesome-icon style="color: #FF5C5E"  :icon="['fas', 'circle']"
                                                 class="footer_btn pr-1"></font-awesome-icon> Inactive
                            </span>
                        </button>
                      </div>
                      <button v-if="canUpdatePaymentSource(paymentSource)" class="edit-btn p-3" @click.prevent="selectPaymentSource(paymentSource)">
                        Edit
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else-if="session && session.customer && !isNew">
                  <div class="centered-block">
                    <div class="step-title">No payment sources found</div>
                  </div>
                </div>
                <div v-if="session && session.customer && session.customer.can_add_credit_card && !isNew" :class="{'order-3': selectedPaymentSource, 'order-2': !selectedPaymentSource }">
                  <h6 class="my-3">Add New Payment Method</h6>
                  <button class="btn card-method" @click="addPaymentSource()" > <font-awesome-icon :icon="['fas', 'credit-card']" class="footer_btn"></font-awesome-icon>
                    Credit Card
                  </button>
                </div>
                <b-form :class="{'order-2': selectedPaymentSource, 'order-3': !selectedPaymentSource }" v-if="selectedPaymentSource || isNew" @submit.prevent="submit()" class="credit-card-form">
                  <div class="card-details">
                    <template v-if="isNew">
                      <b-row>
                        <b-col class="customer-match-formgroup col-pd col-pd-right mt-3">
                          <b-form-group label="Name" class="mb-0">
                            <b-row>
                              <b-col sm="6" class="customer-match-formgroup col-6 col-pd pr-0">
                                <b-form-input class="checkout-form-input" id="first_name" type="text" v-model.trim="first_name" placeholder="First Name"></b-form-input>
                                <div v-if="cardErrors.first_name" class="text-danger input-error text-right pr-5">
                                  <small>{{ cardErrors.first_name }}</small>
                                </div>
                              </b-col>
                              <b-col sm="6" class="customer-match-formgroup col-pd-right col-6">
                                <b-form-input class="checkout-form-input" id="last_name" type="text" v-model.trim="last_name" placeholder="Last Name"></b-form-input>
                                <div v-if="cardErrors.last_name" class="text-danger input-error text-right pr-5">
                                  <small>{{ cardErrors.last_name }}</small>
                                </div>
                              </b-col>
                            </b-row>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-if="canUpdateCardInfo">
                      <b-row class="mt-3">
                        <b-col class="customer-match-formgroup mb-3 col-pd col-pd-right">
                          <b-form-group label="Card Number" label-for="number" class="mb-0">
                            <b-input-group >
                              <b-input-group-prepend>
                                <b-input-group-text>
                                  <font-awesome-icon :icon="cardBrandClass" class="footer_btn"></font-awesome-icon>
                                </b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input id="number" type="tel" ref="number" class="form-control border-right-0 checkout-form-input"
                                            :data-error="(cardErrors.number) ? true : false"
                                            placeholder="Card Number" :maxlength="19"
                                            v-model.trim="number" v-cardformat:formatCardNumber>
                              </b-form-input>
                              <b-input-group-prepend class="input-icon">
                                <b-input-group-text>
                                  <img id="safe-and-secure" :src="require('@/assets/images/lock.svg')"/>
                                  <b-tooltip target="safe-and-secure" triggers="hover"   placement="top">
                                    All payments are Safe and Secure
                                  </b-tooltip>
                                </b-input-group-text>
                              </b-input-group-prepend>
                            </b-input-group>
                            <div v-if="cardErrors.number" class="text-danger input-error text-right pr-5">
                              <small>{{ cardErrors.number }}</small>
                            </div>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </template>
                    <b-row :class="{'mt-3': !isNew}">
                      <b-col sm="4" class="customer-match-formgroup mb-3 col-6 col-pd pr-0">
                        <b-form-group class="dropdown mb-0" label="Expiry Month" label-for="expiry_month">
                          <b-form-select  ref="expiry_month"   class="form-control checkout-form-input"  id="expiry_month" v-model="expiry_month" :options="month"
                                          placeholder="Expiry Month">
                          </b-form-select>
                          <div v-if="cardErrors.expiry" class="text-danger input-error text-right pr-1">
                            <small>{{ cardErrors.expiry }}</small>
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col sm="4" class="customer-match-formgroup mb-3 col-6 col-pd-right pr-sm-0">
                        <b-form-group class="dropdown mb-0" label="Expiry Year" label-for="expiry_year">
                          <b-form-select id="expiry_year" v-model="expiry_year" :options="year"
                                         placeholder="Expiry Year" class="form-control checkout-form-input">
                          </b-form-select>
                          <div v-if="cardErrors.expiry" class="text-danger input-error text-right pr-1">
                            <small>{{ cardErrors.expiry }}</small>
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col v-if="canUpdateCardInfo" sm="4" class="customer-match-formgroup col-pd col-pd-right col-6 mb-3">
                        <b-form-group label="Cvv Code" label-for="cvv_code" class="mb-0">
                          <b-input-group>
                            <b-form-input type="number" class="border-right-0 checkout-form-input" id="cvv_code" ref="cvv_code" :data-error="(cardErrors.cvv_code) ? true : false"
                                          placeholder="CVV" pattern="\d*"
                                          v-model.trim="cvv_code" v-cardformat:formatCardCVC></b-form-input>
                            <b-input-group-prepend class="input-icon">
                              <b-input-group-text>
                                <img id="help" :src="require('@/assets/images/help.svg')"/>
                                <b-tooltip target="help" triggers="hover" placement="top">
                                  3 or 4 Digits usually found on the back of your card
                                </b-tooltip>
                              </b-input-group-text>
                            </b-input-group-prepend>
                          </b-input-group>
                          <div v-if="cardErrors.cvv_code" class="text-danger input-error text-right pr-4">
                            <small>{{ cardErrors.cvv_code }}</small>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                  <b-form-group v-if="!isNew" label="">
                    <b-form-checkbox
                      id="billShipSame"
                      class="billing-information"
                      v-model="billShipSame"
                      name="billShipSame"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Billing same as shipping information
                    </b-form-checkbox>
                  </b-form-group>
                  <div  v-if="!billShipSame && !isNew">
                    <b-row>
                      <b-col class="pr-0 col-pd">
                        <label for="address1" v-if="isIE">Address</label>
                        <b-form-group label="" label-for="address1">
                          <div data-for="address1" class="placeholder-label">Address</div>
                          <b-form-input id="address1" type="text" v-model.trim="customer.address1" placeholder="Street Address"
                                        class="customer checkout-form-input" :disabled="billShipSame"></b-form-input>
                          <div v-if="fieldErrors.address1" class="text-danger input-error text-right pr-1">
                            <small>{{ fieldErrors.address1 }}</small>
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <label for="address2" v-if="isIE">Address 2</label>
                        <b-form-group label="" label-for="address2">
                          <div data-for="address2" class="placeholder-label">Address 2</div>
                          <b-form-input id="address2" type="text" v-model.trim="customer.address2" placeholder="Street Address 2"
                                        class="customer checkout-form-input" :disabled="billShipSame"></b-form-input>
                          <div v-if="fieldErrors.address2" class="text-danger input-error text-right pr-1">
                            <small>{{ fieldErrors.address2 }}</small>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="pr-0 col-pd">
                        <label for="city" v-if="isIE">City</label>
                        <b-form-group label="" label-for="city">
                          <div data-for="city" class="placeholder-label">City</div>
                          <b-form-input id="city" type="text" v-model.trim="customer.city" placeholder="City"
                                        class="customer checkout-form-input" :disabled="billShipSame"></b-form-input>
                          <div v-if="fieldErrors.city" class="text-danger input-error text-right pr-1">
                            <small>{{ fieldErrors.city }}</small>
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col class="col-pd-right">
                        <label for="country" v-if="isIE">Country</label>
                        <b-form-group label="" label-for="country">
                          <div data-for="country" class="placeholder-label">Country</div>
                          <b-form-select id="country" v-model="customer.country" :options="countries" placeholder="Country" @change="countryChanged" class="customer select checkout-form-input"></b-form-select>
                          <div v-if="fieldErrors.country" class="text-danger input-error text-right pr-1">
                            <small>{{ fieldErrors.country }}</small>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="pr-0 col-pd">
                        <div class="customer-match-formgroup">
                          <label for="state" v-if="isIE">State</label>
                          <b-form-group class="dropdown" label="" label-for="state">
                            <div data-for="state" class="placeholder-label">State</div>
                            <b-form-select v-if="isUsOrCA()" id="state" v-model="customer.state"
                                           :options="getStates()" placeholder="State" class="customer checkout-form-input"
                            ></b-form-select>
                            <b-form-input v-if="!isUsOrCA()" id="state" type="text"
                                          v-model.trim="customer.state" placeholder="State" class="customer checkout-form-input"
                            ></b-form-input>
                            <div v-if="fieldErrors.state" class="text-danger input-error text-right pr-1">
                              <small>{{ fieldErrors.state }}</small>
                            </div>
                          </b-form-group>
                        </div>
                      </b-col>
                      <b-col>
                        <label for="zip" v-if="isIE"> Code</label>
                        <b-form-group label="" label-for="zip">
                          <div data-for="zip" class="placeholder-label">Zip Code</div>
                          <b-form-input id="zip" :formatter="zipFormat" type="text" v-model.trim="customer.zip" placeholder="Postal Code"
                                        class="customer checkout-form-input" :disabled="billShipSame"></b-form-input>
                          <div v-if="fieldErrors.zip" class="text-danger input-error text-right pr-1">
                            <small>{{ fieldErrors.zip }}</small>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                  <b-row class="mt-3">
                    <b-col class="col-pd" cols="6" sm="4">
                      <button type="button"
                        class="btn-base input-choice-btn new-btn-outline-success stroke-2x paymemt-method-cancel"
                        @click.prevent="goBack()"
                      >
                        Cancel
                      </button>

                    </b-col>
                    <b-col class="col-pd" cols="6" sm="4">
                      <button
                        class="btn-block btn-base input-choice-btn input-btn"
                        type="submit"
                      >
                        <span v-html="input.formatted_label"></span>
                      </button>
                    </b-col>
                  </b-row>
                </b-form>
                <div class="d-flex justify-content-end info-privacy-container order-4">
                  <img class="privacy-container-img" :src="require('@/assets/images/Secure-Connection.svg')"/>
                </div>
              </div>
            </div>
          </b-col>
        </div>
      </section>
    </div>
    <b-row v-if="!selectedPaymentSource && !isNew" class="justify-content-center boxes bottom-space m-auto">
      <b-col v-if="session && session.can_undo" xs="6" md="5" lg="4" class="life-btn-yes-no">
        <button type="button" @click="goBack()" class="btn-base input-choice-btn new-btn-outline-success stroke-2x">Back</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {PaymentSource, PaymentSourceStrings, PaymentUpdateAllowed, TranResponse} from '../constants'
import {getExpDate, isTestCard, formatZipField, getCountryStates, isCountryUSOrCA, updateRequiredFields,
  getCountries} from '../utils'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Vue from 'vue'

if (process.env.VUE_APP_CAPTCHA_SITE_KEY) {
  Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
    loaderOptions: {
      explicitRenderParameters: {
        badge: 'bottomright',
        size: 'invisible'
      }
    }
  })
}

export default {
  name: 'PaymentInfo',
  props: {
    input: Object
  },
  data: function() {
    return {
      first_name: null,
      last_name: null,
      number: null,
      expiry: null,
      expiry_month: null,
      expiry_year: null,
      cvv_code: null,
      is_default: false,
      isNew: false,
      selectedPaymentSource: null,
      billShipSame: false,
      paymentSources: [],
      paymentSourceFields: [
        {key: 'source', label: 'Type'},
        {key: 'card', label: 'Account Info'},
        {key: 'edit', label: 'Action'}
      ],
      cardErrors: {},
      cardBrand: null,
      month: [
        {value: null, text: 'Exp Month', disabled: true},
        {value: '01', text: '01'},
        {value: '02', text: '02'},
        {value: '03', text: '03'},
        {value: '04', text: '04'},
        {value: '05', text: '05'},
        {value: '06', text: '06'},
        {value: '07', text: '07'},
        {value: '08', text: '08'},
        {value: '09', text: '09'},
        {value: '10', text: '10'},
        {value: '11', text: '11'},
        {value: '12', text: '12'}
      ],
      customer: {
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        country: 'US',
        ship_address1: null,
        ship_address2: null,
        ship_city: null,
        ship_company: null,
        ship_country: 'US',
        ship_first_name: null,
        ship_last_name: null,
        ship_state: null,
        ship_zip: null
      },
      fieldErrors: {}
    }
  },
  computed: {
    ...mapState(['session', 'isIE', 'captchaLoaded', 'campaign']),
    cardBrandClass() {
      return this.getBrandClass(this.cardBrand)
    },
    year: function() {
      let years = [
        {value: null, text: 'Exp Year', disabled: true}
      ]
      let currentYear = new Date().getFullYear()
      for (let i = currentYear; i < currentYear + 20; i++) {
        years.push({value: i.toString(), text: i})
      }
      return years
    },
    countries() {
      return getCountries(this.session)
    },
    canUpdateCardInfo: function() {
      return this.isNew || (this.selectedPaymentSource && this.selectedPaymentSource.canUpdate === PaymentUpdateAllowed.YES)
    }
  },
  watch: {
    // Note: since CVC can be 3 OR 4 digits we don't watch it
    number: function(val) {
      if (val !== null) {
        let number = val.replace(/\s/g, '')
        if (number && number.length > 12) {
          if (this.$cardFormat.validateCardNumber(val) || isTestCard(val, this.session, this.customer)) {
            this.cardErrors.number = null
          } else {
            this.cardErrors.number = 'Invalid Credit Card Number.'
          }
        }
      }
    },
    expiry_month: function(val) {
      if (val !== null) {
        if (this.expiry_year) {
          val = val + ' / ' + this.expiry_year.toString().slice(2)
          if (this.$cardFormat.validateCardExpiry(val)) {
            this.cardErrors.expiry = null
          } else {
            this.cardErrors.expiry = 'Invalid Expiration Date.'
          }
        }
      }
    },
    expiry_year: function(val) {
      if (val !== null) {
        if (this.expiry_month) {
          val = this.expiry_month + ' / ' + val.toString().slice(2)
          if (this.$cardFormat.validateCardExpiry(val)) {
            this.cardErrors.expiry = null
          } else {
            this.cardErrors.expiry = 'Invalid Expiration Date.'
          }
        }
      }
    },
    cvv_code: function(val) {
      if (val !== null) {
        if (val === '' || val.trim() === '') {
          this.cardErrors.cvv_code = 'Invalid CVV Code.'
        } else if (val.length > 2) {
          this.cardErrors.cvv_code = ''
        }
      }
    },
    first_name: function(val) {
      if (val !== null) {
        const letter = '[a-zA-Z][a-zA-Z ]+'
        if (val.match(letter)) {
          this.cardErrors.first_name = null
        } else {
          this.cardErrors.first_name = 'First name is required'
        }
      }
    },
    last_name: function(val) {
      if (val !== null) {
        var letter = '[a-zA-Z][a-zA-Z ]+'
        if (val.match(letter)) {
          this.cardErrors.last_name = null
        } else {
          this.cardErrors.last_name = 'Last name is required'
        }
      }
    }
  },
  methods: {
    canUpdatePaymentSource: function(paymentSource) {
      return paymentSource.canUpdate !== PaymentUpdateAllowed.NO && !this.selectedPaymentSource
    },
    selectPaymentSource: function(paymentSource) {
      if (this.canUpdatePaymentSource(paymentSource)) {
        this.isNew = false
        this.is_default = paymentSource.isDefault
        this.selectedPaymentSource = paymentSource
        this.expiry = paymentSource.expDate
        if (this.expiry) {
          let expiry = this.expiry.split('/')
          this.expiry_month = expiry[0]
          this.expiry_year = new Date().getFullYear().toString().slice(0, 2) + expiry[1]
        }
      }
      this.cardErrors.number = null
      this.cardErrors.first_name = null
      this.cardErrors.last_name = null
      this.cardErrors.cvv_code = null
      this.cardErrors.expiry = null
    },
    addPaymentSource: function() {
      if (this.selectedPaymentSource) {
        this.goBack()
      }
      if (this.session && this.session.customer) {
        this.isNew = true
        this.first_name = null
        this.last_name = null
        this.number = null
        this.expiry_month = null
        this.expiry_year = null
        this.cvv_code = null
        this.is_default = true
        this.cardErrors.number = null
        this.cardErrors.first_name = null
        this.cardErrors.last_name = null
        this.cardErrors.cvv_code = null
        this.cardErrors.expiry = null
      }
      this.isNew = true
    },
    submit: function() {
      if (this.validate()) {
        return
      }
      let params = {
        exp_month: this.expiry_month,
        exp_year: this.expiry_year.toString(),
        is_default: !!(this.selectedPaymentSource && this.selectedPaymentSource.is_default)
      }
      let method = 'add_credit_card'
      if (this.canUpdateCardInfo) {
        params['number'] = this.number
        params['cvv_code'] = this.cvv_code
      }
      if (this.isNew) {
        params['title'] = this.first_name + ' ' + this.last_name
      } else if (this.selectedPaymentSource) {
        params['id'] = this.selectedPaymentSource.id
        method = 'update_credit_card'
      } else {
        this.$emit('submit', this.input)
        return
      }
      this.$store.commit('busy')
      if (this.captchaLoaded && this.$recaptcha) {
        this.$recaptcha(method)
          .then(token => {
            params['recaptcha'] = token
            params['recaptcha_action'] = method
            this._submit(method, params)
          }, _ => {
            this.$store.commit('ready')
          })
      } else {
        this._submit(method, params)
      }
    },
    _submit: function(method, params) {
      this.$store.dispatch(method, params)
        .then(() => {
          this.$store.commit('ready')
          const messages = [`Your payment method has been ${this.isNew ? 'added' : 'updated'}.`]
          this.$emit('submit', this.input, { updatePaymentInfo: true }, messages)
          if (this.billShipSame) {
            this.customer['address1'] = this.customer['ship_address1']
            this.customer['city'] = this.customer['ship_city']
            this.customer['state'] = this.customer['ship_state']
            this.customer['zip'] = this.customer['ship_zip']
          }
          this.$store.dispatch('update_customer', this.customer)
            .then(customer => {
              console.log(customer)
            })
            .catch(err => {
              if (err.response.status === 400) {
                this.$store.commit('error', err)
              } else {
                this.$store.commit('critical_error', err)
              }
            })
        })
        .catch(err => {
          if (err && err.response && err.response.status === 400) {
            let errors = []

            Object.keys(err.response.data).forEach(key => {
              errors = errors.concat(err.response.data[key])
            })

            this.$store.commit('error', errors)
          } else {
            this.$store.commit('critical_error', err)
          }
        })
    },
    goBack: function() {
      if (this.selectedPaymentSource || this.isNew) {
        this.selectedPaymentSource = null
        this.isNew = false
      } else {
        this.$emit('back')
      }
    },
    validate: function() {
      this.cardErrors = {}
      let hasError = false
      if (this.canUpdateCardInfo) {
        // validate card number
        if (!this.$cardFormat.validateCardNumber(this.number) && !isTestCard(this.number, this.session, this.customer)) {
          this.cardErrors.number = 'Invalid Credit Card Number.'
          hasError = true
        }

        // validate card CVC
        if (!this.$cardFormat.validateCardCVC(this.cvv_code)) {
          this.cardErrors.cvv_code = 'Invalid CVV Code.'
          hasError = true
        }
      }
      if (this.isNew) {
        // validate card first name
        if (this.first_name === null) {
          this.cardErrors.first_name = 'Invalid first name'
          hasError = true
        }

        // validate card last name
        if (this.last_name === null) {
          this.cardErrors.last_name = 'Invalid last name'
          hasError = true
        }
      }
      // validate card expiry
      if (this.expiry_month === null || this.expiry_year === null || !this.$cardFormat.validateCardExpiry(this.expiry_month + ' / ' + this.expiry_year.toString().slice(2))) {
        this.cardErrors.expiry = 'Invalid Expiration Date.'
        hasError = true
      }

      if (!this.billShipSame) {
        let requiredFields = [
          'address1',
          'city',
          'zip',
          'country'
        ]

        updateRequiredFields(requiredFields, this.customer.country)

        let existingFieldsErrors = {...this.fieldErrors}
        requiredFields.forEach(field => {
          let value = this.customer[field]
          existingFieldsErrors[field] = null
          if (!value || value.length < 1) {
            existingFieldsErrors[field] = 'This field is required.'
            hasError = true
          }
        })
        this.fieldErrors = existingFieldsErrors
      }

      return hasError
    },
    getBrandClass: function(brand) {
      let cardBrandToClass = {
        'jcb': ['fab', 'cc-jcb'],
        'amex': ['fab', 'cc-amex'],
        'visa': ['fab', 'cc-visa'],
        'unknown': ['fas', 'credit-card'],
        'discover': ['fab', 'cc-discover'],
        'diners': ['fab', 'cc-diners-club'],
        'mastercard': ['fab', 'cc-mastercard']
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    },
    getCardIcon: function(brand) {
      let cardBrandToClass = {
        'jcb': 'jcb',
        'amex': 'amex',
        'visa': 'visa',
        'unknown': 'credit-card',
        'discover': 'discover',
        'diners': 'diners',
        'mastercard': 'mastercard'
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    },
    getStates() {
      return getCountryStates(this.customer.country, this.campaign.blacklisted_states)
    },
    countryChanged() {
      this.customer.state = ''
      this.customer.zip = ''
    },
    isUsOrCA() {
      return isCountryUSOrCA(this.customer.country)
    },
    zipFormat(value) {
      return formatZipField(value, this.customer.country)
    }
  },
  beforeDestroy() {
    if (this.$recaptchaInstance && this.captchaLoaded) {
      this.$recaptchaInstance.hideBadge()
    }
  },
  created() {
    if (process.env.VUE_APP_CAPTCHA_SITE_KEY) {
      if (this.captchaLoaded && this.$recaptchaInstance) {
        this.$recaptchaInstance.showBadge()
      } else {
        this.$recaptchaLoaded()
          .then(_ => {
            this.$store.commit('captcha_loaded')
            this.$recaptchaInstance.showBadge()
          })
      }
    }

    Object.keys(this.customer).forEach(key => {
      this.customer[key] = this.session.customer[key]

      if (key === 'country' || key === 'ship_country') {
        this.customer[key] = this.customer[key].toUpperCase()
      }
    })

    this.$store.commit('busy')
    this.$store.dispatch('get_payment_sources')
      .then(paymentSources => {
        this.paymentSources = []
        for (let source of paymentSources) {
          if (this.session && this.session.customer.default_payment_source === source.id) {
            this.paymentSources.push({
              id: source.id,
              isDefault: source.is_default,
              canUpdate: source.can_update,
              isCard: source.payment_source === PaymentSource.CreditCard,
              source: PaymentSourceStrings[source.payment_source],
              type: source.cc_type,
              last4: source.cc_last4,
              expDate: getExpDate(source.cc_exp_date),
              isActive: !source.latest_status || source.latest_status === TranResponse.Success
            })
          }
        }
        if (!this.paymentSources.length) {
          if (paymentSources && paymentSources.length) {
            let source = paymentSources[0]
            this.paymentSources.push({
              id: source.id,
              isDefault: source.is_default,
              canUpdate: source.can_update,
              isCard: source.payment_source === PaymentSource.CreditCard,
              source: PaymentSourceStrings[source.payment_source],
              type: source.cc_type,
              last4: source.cc_last4,
              expDate: getExpDate(source.cc_exp_date),
              isActive: !source.latest_status || source.latest_status === TranResponse.Success
            })
          } else {
            this.isNew = true
          }
        }

        this.$store.commit('ready')
      })
      .catch(err => {
        this.$store.commit('critical_error', err)
      })
  }
}
</script>

<style scoped lang="less">
  .card-design-for-ie {
    display: block;
    margin-left: 10%;
    margin-right: 10%;
  }

  .card-method {
    &.btn {
      color: #333333;
      background-color: #F6F6F6;
      box-shadow: 0 3px 5px #00000029;
      font-size: 16px;
      border-radius: 4px;
      border: 1px solid #F6F6F6 !important;
      text-transform: capitalize !important;
      padding: 0.7rem 1rem;
      svg{
        margin-right: 4px;
      }

      &:focus {
        outline: none;
      }
    }
  }

  .info-privacy-container {
    color: #787878;
    margin-top: 1.8rem;
    margin-left: auto;

    .secure-con-text {
      font-size: 14px;
      font-weight: bold;
    }
    .info-details {
      font-size: 12px;
    }

    .privacy-container-img {
      width: 90%;
    }
  }

  @media only screen and (min-width: 576px) {
    .info-privacy-container {
      margin-left: unset;
      .privacy-container-img {
        width: 36%;
      }
    }
  }
</style>
